import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Instagram, Facebook } from 'lucide-react';
import { supabase } from '@/lib/supabase';

export function Footer() {
  const [footerText, setFooterText] = useState('Lokalaproducenter');
  const [footerDescription, setFooterDescription] = useState('Kopplar samman lokala producenter med konsumenter sedan 2023.');
  const [contactEmail, setContactEmail] = useState('info@lokalaproducenter.se');
  const [contactPhone, setContactPhone] = useState('+46 123 456 789');
  const [instagramUrl, setInstagramUrl] = useState('https://instagram.com');
  const [facebookUrl, setFacebookUrl] = useState('https://facebook.com');
  const [hideInstagram, setHideInstagram] = useState(false);
  const [hideFacebook, setHideFacebook] = useState(false);

  useEffect(() => {
    async function fetchFooterText() {
      const { data: titleData } = await supabase
        .rpc('get_setting', { p_key: 'footer_text' });
      
      const { data: descData } = await supabase
        .rpc('get_setting', { p_key: 'footer_description' });

      const { data: emailData } = await supabase
        .rpc('get_setting', { p_key: 'contact_email' });
      
      const { data: phoneData } = await supabase
        .rpc('get_setting', { p_key: 'contact_phone' });
        
      const { data: instagramData } = await supabase
        .rpc('get_setting', { p_key: 'social_instagram' });
        
      const { data: facebookData } = await supabase
        .rpc('get_setting', { p_key: 'social_facebook' });
        
      const { data: hideInstagramData } = await supabase
        .rpc('get_setting', { p_key: 'hide_instagram' });
        
      const { data: hideFacebookData } = await supabase
        .rpc('get_setting', { p_key: 'hide_facebook' });

      if (titleData) setFooterText(titleData);
      if (descData) setFooterDescription(descData);
      if (emailData) setContactEmail(emailData);
      if (phoneData) setContactPhone(phoneData);
      if (instagramData) setInstagramUrl(instagramData);
      if (facebookData) setFacebookUrl(facebookData);
      if (hideInstagramData) setHideInstagram(hideInstagramData === 'true');
      if (hideFacebookData) setHideFacebook(hideFacebookData === 'true');
    }

    fetchFooterText();
  }, []);

  // Check if any social media is visible
  const hasSocialMedia = (!hideInstagram || !hideFacebook);

  return (
    <footer className="bg-blue-50 text-gray-700 py-12 border-t border-blue-200" data-testid="footer">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <h3 className="text-lg font-semibold mb-4 text-green-700">{footerText}</h3>
            <p className="text-gray-600 text-sm">
              {footerDescription}
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4 text-green-700">Länkar</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-gray-600 hover:text-green-600">Hem</Link></li>
              <li><Link to="/products" className="text-gray-600 hover:text-green-600">Produkter</Link></li>
              <li><Link to="/producers" className="text-gray-600 hover:text-green-600">Producenter</Link></li>
              <li><Link to="/faq" className="text-gray-600 hover:text-green-600">Vanliga frågor</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4 text-green-700">Kontakt</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center">
                <Mail size={16} className="mr-2 text-green-600" />
                <a href={`mailto:${contactEmail}`} className="text-gray-600 hover:text-green-600">
                  {contactEmail}
                </a>
              </li>
              <li className="flex items-center">
                <Phone size={16} className="mr-2 text-green-600" />
                <a href={`tel:${contactPhone.replace(/\s/g, '')}`} className="text-gray-600 hover:text-green-600">
                  {contactPhone}
                </a>
              </li>
            </ul>
          </div>
          
          {hasSocialMedia && (
            <div>
              <h3 className="text-lg font-semibold mb-4 text-green-700">Följ oss</h3>
              <div className="flex space-x-4">
                {!hideInstagram && (
                  <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-700">
                    <Instagram size={20} />
                  </a>
                )}
                {!hideFacebook && (
                  <a href={facebookUrl} target="_blank" rel="noopener noreferrer" className="text-green-600 hover:text-green-700">
                    <Facebook size={20} />
                  </a>
                )}
              </div>
            </div>
          )}
        </div>
        
        <div className="mt-12 pt-6 border-t border-gray-200 text-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} {footerText}. Alla rättigheter förbehållna.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;